<template>
	<div class="password">
		<!--顶部搜索框 -->
		<div class="nav">
			<van-icon name="arrow-left" size="1.2rem" color="#fff" @click="back" />
			<span>找回密码</span>
			<span></span>
		</div>
		<div class="main">
			<van-cell-group v-if="status">
				<van-field v-model="usertel" clearable @blur="testing" placeholder="请输入手机号" label="手机号" />
				<van-field v-model="sms" clearable @blur="testing" placeholder="手机验证码" label="验证码">
					<van-button slot="button" size="small" type="primary" :disabled="code" @click="getcode">
						{{buttonMsg}}</van-button>
				</van-field>
			</van-cell-group>
			<van-cell-group v-else>
				<van-field v-model="password" type="password" clearable placeholder="请输入新密码" label="新密码" />
				<van-field v-model="newpassword" type="password" clearable placeholder="确认新密码" label="确认新密码" />
			</van-cell-group>
			<div class="btn">
				<van-button v-if="status" slot="button" size="small" type="primary" :disabled="nextCode" @click="next">
					下一步</van-button>
				<van-button v-else slot="button" size="small" type="primary" @click="submit">确定</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				status: true,
				usertel: '',
				sms: '',
				password: '',
				newpassword: '',
				buttonMsg: '获取验证码',
				nextCode: true,
				code: false,
				iphon: '',
				codes: ''
			}
		},
		methods: {
			//验证填写信息
			testing() {
				var that = this;
				if (that.usertel === '') {
					that.$toast('请填写手机号');
					return false;
				} else if (that.usertel && (!(/^[1][345789]\d{9}$/).test(that.usertel) || !(/^[1-9]\d*$/).test(that.usertel) ||
					that.usertel.length !== 11)) {
					that.$toast('手机号码不符合规范');
					return false;
				}
				if (that.sms === '') {
					that.$toast('请填写验证码');
					return false;
				}

				that.nextCode = false;
			},
			//下一步
			next() {
				if (this.usertel != this.iphon || this.sms != this.codes) {
					this.$toast('验证码错误');
					return false;
				} else {
					this.status = false
				}
			},
			//提交
			submit() {
				if (this.password == '') {
					this.$toast('密码不能为空');
				} else if (this.password != this.newpassword) {
					this.$toast('两次密码不一致');
				} else {
					this.$axios.post(baseUrl + '/mobile/User/retrievePassword', {
						tel: this.usertel,
						password: this.password
					}).then((res) => {
						if (res.data.code == 7) {
							this.$toast(res.data.msg);
							setTimeout(() => {
								this.$router.push({
									path: '/Login'
								})
							}, 1000)
						} else {
							this.$toast(res.data.msg);
						}
					}).catch((err) => {
						console.log(err);
					});
				}
			},
			//获取验证码
			getcode() {
				if (this.usertel === '') {
					this.$toast('请填写手机号');
					return false;
				} else if (this.usertel && (!(/^[1][345789]\d{9}$/).test(this.usertel) || !(/^[1-9]\d*$/).test(this.usertel) ||
					this.usertel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				} else {
					this.code = false
				}
				this.$axios.post(baseUrl + '/mobile/User/get_retrieve_password', {
					tel: this.usertel
				}).then((res) => {
					if (res.data.code == 2001) {
						this.$toast(res.data.msg);
						this.iphon = res.data.data.tel;
						this.codes = res.data.data.code;
						this.buttonMsg = 60;
						this.code = true
						var auth_timer = setInterval(() => {
							this.buttonMsg--;
							if (this.buttonMsg <= 0) {
								this.buttonMsg = '获取验证码'
								this.code = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		}
	}
</script>

<style scoped>
	@import "password.css"
</style>


// WEBPACK FOOTER //
// src/components/password/password.vue